import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import MassOfferingMassRequestMinDateDescription from '../MassOfferingMassRequestMinDateDescription';

export const CannotAddOfferingDescription = ({
  isMassDateInFuture,
  unavailableBecauseOfMinimumFromDate,
  unavailableBecauseOfEvenDistribution,
  massOfferingMassRequestMinDate,
}) => {
  let text = <></>;
  if (unavailableBecauseOfMinimumFromDate && massOfferingMassRequestMinDate) {
    text = (
      <Tooltip
        title={
          <MassOfferingMassRequestMinDateDescription
            massOfferingMassRequestMinDate={massOfferingMassRequestMinDate}
          />
        }
      >
        Brak możliwości zamówienia intencji&nbsp;
        <InfoCircleOutlined
          style={{ color: '#1890ff', cursor: 'help', position: 'relative', top: '-1px' }}
        />
      </Tooltip>
    );
  } else if (unavailableBecauseOfEvenDistribution) {
    text = (
      <Tooltip title="Tymczasowo nie można zamówić intencji online na tę Mszę Świętą, proszę wybrać inny termin.">
        Tymczasowy brak możliwości zamówienia intencji&nbsp;
        <InfoCircleOutlined
          style={{ color: '#1890ff', cursor: 'help', position: 'relative', top: '-1px' }}
        />
      </Tooltip>
    );
  } else if (isMassDateInFuture) {
    text = <>Brak wolnych intencji</>;
  } else {
    text = <>Msza Święta już się odbyła</>;
  }

  return <Typography.Text>{text}</Typography.Text>;
};

CannotAddOfferingDescription.propTypes = {
  isMassDateInFuture: PropTypes.bool.isRequired,
  unavailableBecauseOfMinimumFromDate: PropTypes.bool.isRequired,
  unavailableBecauseOfEvenDistribution: PropTypes.bool.isRequired,
  massOfferingMassRequestMinDate: PropTypes.string,
};
